import { addCatalogsAction } from '../slice/catalog.slice'
import { fetchCategoriesAction } from '../slice/template-category.slice';
import { clearResourcesAction } from '../slice/resources';
import {
  addBulkItem as addBulkItemAPI,
  addCategory as addCategoryAPI,
  addItem as addItemAPI,
  addLabor as addLaborAPI,
  addLevel as addLevelAPI,
  addNoPoStock as addNoPoStockAPI,
  checkMaterialUsage as checkMaterialUsageAPI,
  deleteCategory as deleteCategoryAPI,
  deleteItem as deleteItemAPI,
  deleteLabor as deleteLaborAPI,
  deleteLevel as deleteLevelAPI,
  editItem as editItemAPI,
  editLabor as editLaborAPI,
  getCategories as getCategoriesAPI,
  getInventoryList as getInventoryListAPI,
  getInventoryLists as getInventoryListsAPI,
  getItem as getItemAPI,
  getItems as getItemsAPI,
  getInventoryItems as getInventoryItemsAPI,
  getLabor as getLaborAPI,
  getLaborList as getLaborListAPI,
  getLabors as getLaborsAPI,
  getLevel as getLevelAPI,
  getLevels as getLevelsAPI,
  getTransactionsList as getTransactionsListAPI,
  getUnits as getUnitsAPI,
  getVendorCategories as getVendorCategoriesAPI,
  listCategories as listCategoriesAPI,
  saveUnits as saveUnitsAPI,
  updateBulkItems as updateBulkItemsAPI,
  updateCategory as updateCategoryAPI,
  updateItemStock as updateItemStockAPI,
  updateLevel as updateLevelAPI,
  listTemplateCategories as listTemplateCategoriesAPI,
  setBulkMaterialDuplicateVisibilityAPI,
  suggestMaterialsAPI,
  moveItems as moveItemsAPI,
  countAffectedTemplatesAPI,
  massReplaceMaterialsAPI,
  getInventoryListWithDuplicates as getInventoryListWithDuplicatesAPI,
  replaceAndHideMaterialsAPI,
  getSwapAffectedCountAPI,
  swapMaterialsAPI,
  getSwapMaterialsListAPI,
  getInventoryCounts as getInventoryCountsAPI
} from '../api/inventory.api'
import { getItemStock as getItemStockAPI } from '../api/stock.api'
import _ from 'lodash';

export const getInventoryCounts = (params = {}) => {
  return (dispatch) => {
    return getInventoryCountsAPI(params).then((response) => {
      return response;
    });
  };
};

export const getInventoryList = () => {
  return (dispatch, getState) => {
    return getInventoryListAPI()
  }
}

export const getLevels = (params = {}) => {
  return (dispatch, getState) => {
    return getLevelsAPI(params);
  };
};

export const getLevel = (id, allLabors = false) => {
  return (dispatch, getState) => {
    return getLevelAPI(id, allLabors)
  }
}

export const getItems = (params = '') => {
  return (dispatch, getState) => {
    return getItemsAPI(params)
  }
}

export const getInventoryItems = (params = {}) => {
  return (dispatch, getState) => {
    const queryParams = typeof params === 'string' ? { categoryId: params } : params;
    return getInventoryItemsAPI(queryParams)
  }
}

export const getCategories = (params = {}) => {
  return (dispatch, getState) => {
    return getCategoriesAPI(params)
  }
}

export const listCategories = (params = {}) => {
  return (dispatch, getState) => {
    return listCategoriesAPI(params).then((response) => {
      dispatch(addCatalogsAction(response))
    }).catch((e) => {
      console.error(e)
    })
  }
}
let inFlightTemplateCategories = null;

export const listTemplateCategories = (forceRefresh = false) => {
  return (dispatch, getState) => {
    const categories = getState()?.category?.categories || [];
    if (!forceRefresh && categories.length > 0) {
      return Promise.resolve(categories);
    }
    if (inFlightTemplateCategories) {
      return inFlightTemplateCategories;
    }
    inFlightTemplateCategories = listTemplateCategoriesAPI().then((response) => {
      dispatch(fetchCategoriesAction(response));
      inFlightTemplateCategories = null;
      return response;
    }).catch((e) => {
      inFlightTemplateCategories = null;
      console.error(e);
      return Promise.reject(e);
    });
    return inFlightTemplateCategories;
  }
}
export const getVendorCategories = (categoryFilter) => {
  return (dispatch, getState) => {
    return getVendorCategoriesAPI(categoryFilter)
  }
}

export const addBulkItem = (data, configs = {}) => {
  return (dispatch, getState) => {
    return addBulkItemAPI(data, configs)
  }
}

export const checkMaterialUsage = (materials, options) => {
  return (dispatch, getState) => {
    return checkMaterialUsageAPI(materials, options)
  }
}

export const addItem = (data) => {
  return (dispatch, getState) => {
    return addItemAPI(data)
  }
}

export const getItem = (data) => {
  return (dispatch, getState) => {
    return getItemAPI(data)
  }
}

export const editItem = (data, itemId) => {
  return (dispatch, getState) => {
    return editItemAPI(data, itemId)
  }
}

export const updateLevel = (data, itemId, options = {}) => {
  return (dispatch, getState) => {
    return updateLevelAPI(data, itemId, options)
  }
}

export const updateCategory = (data, itemId) => {
  return (dispatch, getState) => {
    return updateCategoryAPI(data, itemId).then(res => {
      dispatch(listCategories());
      return res;
    }).catch(e => console.error(e));
  }
}

export const deleteLevel = (data, itemId) => {
  return (dispatch, getState) => {
    return deleteLevelAPI(data, itemId)
  }
}

export const deleteCategory = ({ data, itemId, categoryId = '' }) => {
  return (dispatch, getState) => {
    return deleteCategoryAPI({ data, itemId, categoryId }).then(res => {
      dispatch(listCategories());
      return res;
    }).catch(e => console.error(e));
  }
}

export const deleteItem = (data, itemId) => {
  return (dispatch, getState) => {
    return deleteItemAPI(data, itemId)
  }
}

export const addCategory = (data) => {
  return (dispatch, getState) => {
    return addCategoryAPI(data).then(res => {
      dispatch(listCategories());
      return res;
    }).catch(e => console.error(e));
  }
}

export const addLevel = (data) => {
  return (dispatch, getState) => {
    return addLevelAPI(data)
  }
}

export const getLaborList = (params = {}) => {
  return (dispatch, getState) => {
    return getLaborListAPI(params);
  };
};


/**
 * Creates a new labor resource and invalidates cached resources in Redux.
 *
 * @param {Object} data - Labor resource payload.
 * @returns {Function} Redux thunk action.
 */
export const addLabor = (data) => {
  return (dispatch) => {
    return addLaborAPI(data).then(res => {
      dispatch(clearResourcesAction());
      return res;
    });
  }
}

export const getLabor = (data) => {
  return (dispatch, getState) => {
    return getLaborAPI(data)
  }
}

/**
 * Updates a labor resource and synchronizes redux store state.
 *
 * @param {Object} data - Updated labor payload.
 * @param {string} LaborId - Labor ID to update.
 * @param {Object} [options] - Additional options.
 * @returns {Function} Redux thunk action.
 */
export const editLabor = (data, LaborId, options = {}) => {
  return (dispatch, getState) => {
    return editLaborAPI(data, LaborId, options).then(res => {
      const currentResources = _.get(getState(), 'resources.list', []);
      if (Array.isArray(currentResources) && currentResources.length > 0) {
        const mappedData = { ...data };
        if (data.isPersonnel !== undefined) {
          mappedData.is_personnel = data.isPersonnel;
        }
        if (data.cost !== undefined && data.cost !== null && data.cost !== '') {
          mappedData.cost = parseFloat(data.cost);
        }
        const updatedResources = currentResources.map(r => r.id === LaborId ? { ...r, ...mappedData } : r);
        dispatch({ type: 'resources/addResources', payload: { resources: updatedResources } });
      }
      return res;
    });
  }
}

export const deleteLabor = (data, LaborId) => {
  return (dispatch, getState) => {
    return deleteLaborAPI(data, LaborId)
  }
}

export const getLabors = (id) => {
  return (dispatch, getState) => {
    return getLaborsAPI(id)
  }
}

export const saveUnits = (data) => {
  return (dispatch, getState) => {
    return saveUnitsAPI(data)
  }
}

export const getUnits = (params) => {
  return (dispatch, getState) => {
    return getUnitsAPI(params)
  }
}

export const updateItemStock = (data) => {
  return (dispatch, getState) => {
    return updateItemStockAPI(data)
  }
}

export const getTransactionsList = (params = {}) => {
  return (dispatch, getState) => {
    // Handle legacy calls where params might be a string (location)
    const queryParams = typeof params === 'string' ? { location: params } : params;
    return getTransactionsListAPI(queryParams)
  }
}

export const getItemStock = (itemId) => {
  return (dispatch, getState) => {
    return getItemStockAPI(itemId)
  }
}

export const addNoPoStock = (data) => {
  return (dispatch, getState) => {
    return addNoPoStockAPI(data)
  }
}

export const getInventoryLists = (params = {}, configs = {}) => {
  return (dispatch, getState) => {
    return getInventoryListsAPI(params, configs)
  }
}


export const updateBulkItems = (data, configs = {}) => {
  return (dispatch) => {
    return updateBulkItemsAPI(data, configs)
  }
}

export const setBulkMaterialDuplicateVisibility = (updates) => {
  return (dispatch, getState) => {
    return setBulkMaterialDuplicateVisibilityAPI(updates);
  };
};

export const getSuggestedMaterials = (params = {}) => {
  return (dispatch, getState) => {
    return suggestMaterialsAPI(params)
  }
}
export const moveInventoryItems = (data) => {
  return (dispatch) => {
    return moveItemsAPI(data)
  }
}

export const countAffectedTemplates = (params) => {
  return (dispatch) => {
    return countAffectedTemplatesAPI(params)
  }
}

export const massReplaceMaterials = (params) => {
  return (dispatch) => {
    return massReplaceMaterialsAPI(params)
  }
}
export const getInventoryListWithDuplicates = (params = {}) => {
  return (dispatch, getState) => {
    return getInventoryListWithDuplicatesAPI(params)
  }
}

export const replaceAndHideMaterials = (params) => {
  return (dispatch, getState) => {
    return replaceAndHideMaterialsAPI(params);
  };
};

export const getSwapAffectedCount = (params) => {
  return (dispatch) => {
    return getSwapAffectedCountAPI(params);
  };
};

export const swapMaterials = (params) => {
  return (dispatch) => {
    return swapMaterialsAPI(params);
  };
};

export const getSwapMaterialsList = (params) => {
  return (dispatch) => {
    return getSwapMaterialsListAPI(params);
  };
};
